export default "/images/14f0b96b9da1a3ef9cd854514d84e8d3.avif";